import React from 'react';

import { Trans } from '@lyearn/i18n';
import { CreateMediaInput } from '@/types/schema';

export const validateMedias = (medias?: CreateMediaInput[] | null) => {
  const isUploading = medias?.find((media) => !media?.url);

  if (isUploading) {
    return <Trans i18nKey="Form.Error.MediaUploading" />;
  }

  return null;
};
